import { render, staticRenderFns } from "./KPR.vue?vue&type=template&id=0384d27c"
import script from "./KPR.vue?vue&type=script&lang=js"
export * from "./KPR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports